module.exports = __webpack_public_path__ + "img/img_rendering-ballpark.379e2087.jpg";